/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1      Usha       24/01/2020      1973: Related Symptoms Implementation
*********************************************************************************/
//import deepClone from '@mna/utils/deepClone'

export default () => ({
  triageRequest: {
    base64:"",
    sessionId: 0,
    policyNumber: '', // Deprecated in favor of Azure login/signup (TODO)
    gender: '', // F, M
    birthdate: {
      year: '', //1960,
      month: '', //1,
      day: '', //1
        },
     triageSymptom: 'List',
    selectChildBirth: '',
    birthdateSelected: false,
    riskFactorVal:'',
    childBirthName: '',
    selectRecentPhysicalInjury: '',
    isRiskFactorCompleted: false,
    QuickTeleMedAvailableOrNot: '',
    ageInYears: 0, // For BioConfirm section
    ageInDays: 0, // Required by Triage API
    pregnant: '',
        emergency: false,
        RelatedSymptoms: [],
        Symptoms: [],
        questions: {},
        activeMenu:'',
    location: {
      // See: pages/find-care-options/location and features/Map
      // name, parts: { country, postal_code, .. }
    },
    locationMeta: {
      // Derived from Google Map location data
      // Used in submitLocation, getAvailableServices, getEmergencyResults
      // address, latitude, longitude, ...
    },
        presentRelatedSymptomsMap: {}, //CHID-1
        presentRelatedSymptomSelected: [],//CHID-1 
        absentRelatedSymptomsMap: {},//CHID-1
        absentRelatedSymptomSelected: [],//CHID-1
    answers: [],
    additionalAnswers: [],

    selectedCareOptionScore: 0,
    selectedCareOptionName: '',
    // Set in features/Clinics (care options and emergency results map)
    // Rendered in find-care-options/send-information
    selectedProvider: {},

    // For care options: House Visit, Telemedicine, Concierge Care
    serviceRequest: {},
    //To save all list of excluded service id's
    excludedServiceAccessPointId:[],
    isFemaleInPregnantStage:false,
    height:'',
    weight:'',
  },
  triageResponse: {
    errors: {},

    // Session: Emergency

    emergencyNumber: '911', // By country
    // EmergencyServiceProvider[] on successful response
    emergencyServiceProviders: null,
    referenceResponse: null,
    // Processed result from above: { markers[], clinics[] }
    emergencySessionResults: {},

    // Session: Normal

    // After symptoms sent
    questions: [],
    additionalQuestions: [],

    // Returned from getTriageScoreFromAnswers
    scoreResults: [],
    // Derived from above in triage/actions/score, generateRecommendedCareOptions
    recommendedCareOptions: [],
    // Returned from getTriageServiceCategoriesByScore
    // ServiceCategory[] on successful response
    serviceCategoriesByScore: [],
    // ServiceProvider[] on successful response
    serviceProviders: [],
    // Processed result from above: { markers[], clinics[] }
    sessionResults: {},
    //get vendors list
    vendorsList:[],
    //save selected ConnectionType
    selectedConnectionType:''
  },
})
